import React from 'react';
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {WithDevice} from "../../../../core/components/composers/with-device";
import {DeviceViewModel} from "../../../../core/models/device.view-model";
import {EntityScoresWidgetSectionPlaceholder} from "./entity-scores-widget.section.placeholder";
import classNames from "classnames";
import styles from "../../styles/entity-scores-widget-placeholder.module.scss";
import {EntityScoresWidgetHeaderPlaceholder} from "./entity-scores-widget.header.placeholder";
import {ENTITY_SCORES} from "../../entity-scores-widget.consts";

export class EntityScoresWidgetPlaceholderComponentProps extends BaseProps {
  device: DeviceViewModel;
  count: Number;
  gamesCount: Number;
  shouldRenderHeader: Boolean = false;
}

export const EntityScoresWidgetPlaceholder = WithDevice(({
                                                           context,
                                                           device,
                                                           count,
                                                           gamesCount,
                                                           shouldRenderHeader
                                                         }: EntityScoresWidgetPlaceholderComponentProps) => {
  const {isSmallView, isLargeView} = device;

  const shouldRenderEntityHeader: Boolean = shouldRenderHeader && isLargeView;
  const isCompetition = context === ENTITY_SCORES.TYPES.competition

  const sections: Array<Object> = [];
  const countIndex = count === undefined ? (isCompetition ? 3 : 6) : count;
  const gamesCountIndex = gamesCount === undefined ? (isCompetition ? 4 : 1) : gamesCount;

  for (let i = 0; i < countIndex; i++) {
    sections.push({
      key: i,
      count: gamesCountIndex
    });
  }

  const containerProps = {
    className: classNames(
      styles.container,
      {[styles.small_view]: isSmallView},
      {[styles.container_include_header]: shouldRenderEntityHeader}
    )
  }

  return (
    <div {...containerProps}>
      <EntityScoresWidgetHeaderPlaceholder shouldRenderHeader={shouldRenderHeader}/>
      {
        sections.map((section: Object) => <EntityScoresWidgetSectionPlaceholder
          gamesCount={section.count}
          key={section.key}
        />)
      }
    </div>
  )
});
